import SoftBadge from "modules/common/SoftBadge";
import React from "react";

function LatestOrder({ rewardsData }) {
  return (
    <div>
      <div>
        <div className="border-bottom"></div>
        <div className="d-flex flex-row gap-2 flex-wrap mt-4">
          <div className="d-flex align-items-center">
            <span className="fw-bold">Log Days Left :</span>{" "}
            <SoftBadge bg="primary" className="ms-2">
              <span style={{ fontSize: "12px" }}>
                {" "}
                {rewardsData?.latestMedicines?.logDaysLeft}
              </span>
            </SoftBadge>
            <span className="mx-2 fw-bold">|</span>
          </div>
          <div className="d-flex align-items-center">
            <span className="fw-bold">Is Reorder Required:</span>{" "}
            <SoftBadge bg="primary" className="ms-1">
              {rewardsData?.latestMedicines?.isReorderRequired ? (
                <span style={{ fontSize: "12px" }}>True</span>
              ) : (
                <span style={{ fontSize: "12px" }}>False</span>
              )}
            </SoftBadge>
            <span className="mx-2 fw-bold">|</span>
          </div>
          <div className="d-flex align-items-center">
            <span className="fw-bold text-nowrap">Text-1 :</span>{" "}
            <SoftBadge bg="primary" className="ms-1">
              <span style={{ fontSize: "12px" }}>
                {rewardsData?.latestMedicines?.text1}
              </span>
            </SoftBadge>
            <span className="mx-2 fw-bold">|</span>
          </div>
          <div className="d-flex align-items-center">
            <span className="fw-bold text-nowrap">Text-2 :</span>{" "}
            <SoftBadge bg="primary" className="ms-1 text-break text-wrap">
              <span style={{ fontSize: "12px" }}>
                {" "}
                {rewardsData?.latestMedicines?.text2}
              </span>
            </SoftBadge>
          </div>
        </div>
      </div>
      <div
        className="mt-3 gap-3"
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          zIndex: "-1",
        }}
      >
        {rewardsData?.latestMedicines?.medicines?.map((item) => {
          return (
            <div>
              <div className="d-flex bg-white rounded shadow p-2 mt-2">
                <div className="d-flex flex-row gap-2">
                  <img
                    src={item?.image_url?.productUrl}
                    style={{ height: "100px", width: "100px" }}
                  ></img>
                  <div>
                    <div className="fs-2 text-break text-wrap">{item?.name}</div>
                    <div className="border-bottom"></div>
                    <div className="fs-1 text-break text-wrap text-secondary">{item?.type}</div>
                    <div className="border-bottom"></div>
                    <div className="text-break text-wrap text-black">{item?.Dosage}</div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default LatestOrder;
